import { connect } from "react-redux";

import * as selectors from "../selectors";
import * as actions from "../actions";
import ResetPassword from "../components/ResetPassword";

const mapStateToProps = (state, ownProps) => {
  return {
    token: ownProps.routeParams.token,
    isResettingPassword: selectors.isResettingPassword(state),
    resetPasswordFailed: selectors.resetPasswordFailed(state),
    passwordReset: selectors.passwordReset(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onReset: () => dispatch(actions.resetResetPassword()),
    onSend: (password1, password2, token) =>
      dispatch(actions.resetPassword(password1, password2, token))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



/** WEBPACK FOOTER **
 ** ./src/containers/ResetPasswordContainer.js
 **/